/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type { HTTPValidationError, ProjectConnectionPrioritizationDTO } from '../fastAPI.schemas'

/**
 * Return the organisation's connector prioritization per scenario.
 * @summary Get Organisation Connection Prioritization
 */
export const getOrganisationConnectionPrioritization = (signal?: AbortSignal) => {
  return customInstance<ProjectConnectionPrioritizationDTO>({
    url: `/connections/connection-prioritization`,
    method: 'GET',
    signal,
  })
}

export const getGetOrganisationConnectionPrioritizationQueryKey = () => {
  return [`/connections/connection-prioritization`] as const
}

export const getGetOrganisationConnectionPrioritizationQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganisationConnectionPrioritization>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOrganisationConnectionPrioritization>>,
    TError,
    TData
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrganisationConnectionPrioritizationQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganisationConnectionPrioritization>>
  > = ({ signal }) => getOrganisationConnectionPrioritization(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganisationConnectionPrioritization>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetOrganisationConnectionPrioritizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganisationConnectionPrioritization>>
>
export type GetOrganisationConnectionPrioritizationQueryError = HTTPValidationError

/**
 * @summary Get Organisation Connection Prioritization
 */

export function useGetOrganisationConnectionPrioritization<
  TData = Awaited<ReturnType<typeof getOrganisationConnectionPrioritization>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOrganisationConnectionPrioritization>>,
    TError,
    TData
  >
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrganisationConnectionPrioritizationQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Overwrite the organisation's prioritized connectors per scenario.
 * @summary Set Organisation Connection Prioritization
 */
export const setOrganisationConnectionPrioritization = (
  projectConnectionPrioritizationDTO: ProjectConnectionPrioritizationDTO,
) => {
  return customInstance<ProjectConnectionPrioritizationDTO>({
    url: `/connections/connection-prioritization`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: projectConnectionPrioritizationDTO,
  })
}

export const useSetOrganisationConnectionPrioritizationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setOrganisationConnectionPrioritization>>,
    TError,
    { data: ProjectConnectionPrioritizationDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof setOrganisationConnectionPrioritization>>,
  TError,
  { data: ProjectConnectionPrioritizationDTO },
  TContext
> => {
  const mutationKey = ['setOrganisationConnectionPrioritization']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setOrganisationConnectionPrioritization>>,
    { data: ProjectConnectionPrioritizationDTO }
  > = props => {
    const { data } = props ?? {}

    return setOrganisationConnectionPrioritization(data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/connections/connection-prioritization` },
    {
      operationId:
        'set_organisation_connection_prioritization_connections_connection_prioritization_put',
      operationName: 'setOrganisationConnectionPrioritization',
    },
  )

  return customOptions
}

export type SetOrganisationConnectionPrioritizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof setOrganisationConnectionPrioritization>>
>
export type SetOrganisationConnectionPrioritizationMutationBody = ProjectConnectionPrioritizationDTO
export type SetOrganisationConnectionPrioritizationMutationError = HTTPValidationError

/**
 * @summary Set Organisation Connection Prioritization
 */
export const useSetOrganisationConnectionPrioritization = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setOrganisationConnectionPrioritization>>,
    TError,
    { data: ProjectConnectionPrioritizationDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof setOrganisationConnectionPrioritization>>,
  TError,
  { data: ProjectConnectionPrioritizationDTO },
  TContext
> => {
  const mutationOptions = useSetOrganisationConnectionPrioritizationMutationOptions(options)

  return useMutation(mutationOptions)
}
